import React from "react";

export const nlToBr = (str) => {
    if (!str) return '';
    let tokens = str.split('\n');
    if (tokens.length == 1) {
        return str;
    }
    else {
        return tokens.map((t,i) => <span key={i}>
            {i > 0 && <br/>}
            {replaceTabs(t)}
        </span >)
    }
}

const replaceTabs = (str) => {
    let elements = [];
    let word = null;
    let i = 0;
    for (const char of str) {
        if (char == '\t') {
            if (word) elements.push(word);
            elements.push(<span key={"spacer-"+(i++)} className={"d-inline-block ml-3"}></span>);
        } else {
            if (!word) word = "";
            word += char;
        }
    }
    if (word) elements.push(word);
    return elements;
}


